import './MentionsLegales.css';

const MentionsLegales = ({ onClose }) => {
  return (
    <div className="mentions-overlay" onClick={onClose}>
      <div className="mentions-modal" onClick={e => e.stopPropagation()}>
        <button className="mentions-close" onClick={onClose} aria-label="Fermer">×</button>

        <h2>Mentions légales</h2>

        <section className="mentions-section">
          <h3>Éditeur du site</h3>
          <p><strong>Pochard Espaces Verts</strong></p>
          <p>Entreprise Individuelle — micro-entreprise</p>
          <p>SIRET : 991 626 656 00011</p>
          <p>Responsable de publication : Jordan Pochard</p>
          <p>404 Route de Villaudric<br />31340 Villemur-sur-Tarn<br />France</p>
          <p>Téléphone : <a href="tel:+33780643074">07 80 64 30 74</a></p>
          <p>Email : <a href="mailto:pochard.ev@gmail.com">pochard.ev@gmail.com</a></p>
        </section>

        <section className="mentions-section">
          <h3>Hébergeur</h3>
          <p><strong>Hostinger International Ltd</strong></p>
          <p>61 Lordou Vironos Street<br />6023 Larnaca, Chypre</p>
          <p><a href="https://www.hostinger.fr" target="_blank" rel="noopener noreferrer">www.hostinger.fr</a></p>
        </section>

        <section className="mentions-section">
          <h3>Propriété intellectuelle</h3>
          <p>L'ensemble du contenu de ce site (textes, images, visuels) est la propriété exclusive de Pochard Espaces Verts. Toute reproduction, même partielle, est interdite sans autorisation préalable.</p>
        </section>

        <section className="mentions-section">
          <h3>Données personnelles</h3>
          <p>Les informations recueillies via le formulaire de contact (nom, email, téléphone, ville) sont utilisées exclusivement pour répondre à vos demandes. Elles ne sont ni cédées ni revendues à des tiers.</p>
          <p>Conformément à la loi Informatique et Libertés du 6 janvier 1978 modifiée et au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour exercer ce droit, contactez-nous à <a href="mailto:pochard.ev@gmail.com">pochard.ev@gmail.com</a>.</p>
        </section>

        <section className="mentions-section">
          <h3>Cookies</h3>
          <p>Ce site n'utilise pas de cookies de traçage ou publicitaires. Aucune donnée de navigation n'est collectée à des fins commerciales.</p>
        </section>

        <section className="mentions-section">
          <h3>Responsabilité</h3>
          <p>Pochard Espaces Verts s'efforce de maintenir les informations de ce site à jour et exactes. Toutefois, nous ne pouvons garantir l'exactitude, la complétude ou l'actualité des informations diffusées.</p>
        </section>
      </div>
    </div>
  );
};

export default MentionsLegales;
